import * as React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';
import { connect } from 'react-redux';

import { ApplicationState } from '../../store';
import { ToxnotReactComponentPaths } from '../core/ToxnotReactComponentPaths';
import { ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';
import * as CustomerStateController from '../../store/StateControllers/Customers/CustomersStateController';
import { getMyCustomersModals } from './MyCustomerModals';
import Layout from '../Layout';
import MyCustomerDetail from './MyCustomerDetail';
import MyCustomersHome from './MyCustomersHome';
import RequestReports from './RequestReports';
import { LoadingSpinner, LoadingSpinnerSize } from '../core/LoadingSpinner';
import StaticPageReloader from '../StaticPageReloader';
import MyCustomerRequestDetail from './MyCustomerRequestDetail';
import Upsell from '../Upsell/Upsell';
import { ToxnotSignInRequiredComponent } from '../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';
import { MyCustomersProps } from './MyCustomersCommon';


// ===============================================================================
//
// Component that does all the routing for all the Browsing MyCustomer. It
// also loads in all the data for MyCustomers before any sub component is rendered.
//

class MyCustomersBrowse extends ToxnotSignInRequiredComponent<MyCustomersProps> {
    public componentDidMount() {
        this.props.loadAllData();
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [];
    }
    // ===============================================================================

    public renderConcreteComponent() {
        let body: JSX.Element;

        if (this.props.isLoading) {
            body = (
                <div className="tn-section">
                    <div className="tn-section-row">
                        <div className="tn-section-col-12">
                            <div className="text-center">
                                <LoadingSpinner size={LoadingSpinnerSize.Medium} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        else {
            body = (
                <Switch>
                    <Route exact={true} path={ToxnotReactComponentPaths.MyCustomersBrowsePath} component={MyCustomersHome} />
                    <Route exact={false} path={ToxnotReactComponentPaths.MyCustomerDetailPath} component={MyCustomerDetail} />
                    <Route component={StaticPageReloader} />
                </Switch>
            );
        }

        return (
            <Layout options={{ pinAppContentToWindowHeight: true }} modalsRender={this.getModels}>
                {body}
            </Layout>
        );
    }

    // ===============================================================================

    private getModels = () => {
        if (this.props.appServices.userContext === null) {
            throw new Error("User Context was null.");
        }

        return getMyCustomersModals(this.props.appServices.userContext);
    }
}

const MyCustomersBrowseConnect = connect(
    (state: ApplicationState) => ({ appServices: state.appServices, ...state.myCustomersState }),
    CustomerStateController.actionCreators
)(MyCustomersBrowse as any)


// ===============================================================================
//
// Component that does all the routing for all the MyCustomer components.
//
class MyCustomersMain extends React.PureComponent<MyCustomersProps> {
    public render() {
        return (
            <Switch>
                <Route exact={false} path={ToxnotReactComponentPaths.MyCustomersBrowsePath} component={MyCustomersBrowseConnect} />
                <Route exact={true} path={ToxnotReactComponentPaths.RequestReportsPath} component={RequestReports} />
                <Route component={StaticPageReloader} />
            </Switch>
        );
    }
}

export default connect(
    (state: ApplicationState) => ({ appServices: state.appServices, ...state.myCustomersState }),
    CustomerStateController.actionCreators
)(MyCustomersMain as any);